import { ILeftPanelOpenedSetAction } from './types';
import { AT_LEFT_PANEL_OPENED_SET } from './constants';

export const leftPanelOpenedSetAction = (
    opened: boolean
): ILeftPanelOpenedSetAction => ({
    type: AT_LEFT_PANEL_OPENED_SET,
    opened
});
